import React from 'react';
import { Tabs, Switch } from 'antd';
import StudentReports from '../studentReports/studentReports'
import EnrolledReports from '../enrolledReports/enrolledReports';
import ActiveUserReports from '../activeUserReports/activeUserReports';
import StudentAttendanceReports from '../studentAttendance/studentAttendanceDetails';
import InStructoreAttendanceReports from '../studentAttendance/instructoreAttendanceDetails';
const { TabPane } = Tabs;

const ReportTabController = () => {
    return (
        <div className='classesTabContainer'>
             <div className='classesInfoSearch alignRight'>
              <div><h3>Report</h3></div>
              <div><h3></h3></div>
          </div>
            <div>
        <Tabs defaultActiveKey="1">
          {/* <TabPane tab="SCHEDULED CLASSES" key="1">
            <AdminScheduleClass/>
            
          </TabPane> */}
          <TabPane tab="Student Reports" key="2">
            <StudentReports/>
          </TabPane>

          <TabPane tab="Enrollment Reports" key="3">
            <EnrolledReports/>
          </TabPane>

          <TabPane tab="Active User Reports" key="4">
            <ActiveUserReports/>
          </TabPane>

          <TabPane tab="Student Attendance" key="5">
            <StudentAttendanceReports/>
          </TabPane>

          <TabPane tab="Instructor Attendance" key="6">
            <InStructoreAttendanceReports/>
          </TabPane>
          
        </Tabs>
        </div>
       
        </div>
      );
}

export default ReportTabController;
